import { REDIRECT } from "@/imports-files/common/common";

export const ADMIN = 'Administrator';
export const SUB_ADMIN = 'SubAdministrator';


export const CLIENT_ROLES = {
                              CLIENT_ADMIN:  "client_admin",
                              ACCOUNT_OWNER: "account_owner",
                              CLIENT_USER:  "client_user",
                              REVIEWER: "reviewer",
                            }

export const AGENCIES_ROLES = {
                                AGENCY_ADMIN:  "admin",
                                AGENCY_USER:  "user",
                              }

export const SIDEBAR_OPTIONS = [{
  activities: {
    link: '/clients/activities',
    active: false,
    subsidebar_status: 'close',
    title:'View Activity',
    allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN, CLIENT_ROLES.ACCOUNT_OWNER, ADMIN, CLIENT_ROLES.CLIENT_USER, CLIENT_ROLES.REVIEWER, SUB_ADMIN],
    subSidebar_options: {
                              // "add_teams":{
                              //               link: `${REDIRECT.client.quick_setup}add_teams`,
                              //               title:'Add Teams',
                              //               step: 0,
                              //               allowed_user_type:  [CLIENT_ROLES.CLIENT_ADMIN, CLIENT_ROLES.ACCOUNT_OWNER]
                              //             },
                              "company_integrations" :{
                                                          link: `${REDIRECT.client.quick_setup}company_integrations`,
                                                          title:'Company Integrations',
                                                          step: 1,
                                                          allowed_user_type:  [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ]
                                                      },
                              'careers_page':{
                                                link: `${REDIRECT.client.quick_setup}careers_page`,
                                                title:'Career Page',
                                                step: 2,
                                                allowed_user_type:  [CLIENT_ROLES.CLIENT_ADMIN, CLIENT_ROLES.ACCOUNT_OWNER, ]
                                            },
                              'privacy_policy':{
                                  link: `${REDIRECT.client.quick_setup}privacy_policy`,
                                  title:'Privacy Policy',
                                  step: 3,
                                  allowed_user_type:  [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ]
                              },
                              'my_account':{
                                                link: `${REDIRECT.client.quick_setup}my_account`,
                                                title:'My Account',
                                                step: 4,
                                                allowed_user_type:  [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ADMIN,  CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER, SUB_ADMIN]
                                            },
                              'my_integrations':{
                                                link: `${REDIRECT.client.quick_setup}my_integrations`,
                                                title:'My Integrations',
                                                step: 5,
                                                allowed_user_type:  [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN,  CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER, SUB_ADMIN]
                                            },
                              'my_preferences':{
                                                    link: `${REDIRECT.client.quick_setup}my_preferences`,
                                                    title:'My Preferences',
                                                    step: 6,
                                                    allowed_user_type:  [CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER]
                                                }
                          },
  },
  communication: {
    link: REDIRECT.client.communication.inbox,
    active: false,
    subsidebar_status: 'close',
    type: 'menu',
    allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN, CLIENT_ROLES.ACCOUNT_OWNER, CLIENT_ROLES.CLIENT_USER],
    subSidebar_options:{
                          'inbox':{
                                       link: REDIRECT.client.communication.inbox,
                                        title: 'Inbox'
                                  },
                          'sent':{
                                   link: REDIRECT.client.communication.sent,
                                   title: 'Sent'
                                 },

                      },
    title:'Communication',
  },
  jobs: {
    link: '/clients/jobs?job_type=Active',
    active: false,
    subsidebar_status: 'close',
    subSidebar_options: {
                            'job-details'     : {
                                                    link: REDIRECT.client.jobs.edit,
                                                    title:'Job Details',
                                                    step: 0
                                                },
                            'job-options'     : {
                                                    link: REDIRECT.client.jobs.job_options,
                                                    title:'Job Options',
                                                    step: 1
                                                },
                            'interview-stages': {
                                                    link: REDIRECT.client.jobs.interview_stages,
                                                    title:'Interview Stages',
                                                    step: 2
                                                },
                            'interview-details'      : {
                                                    link: REDIRECT.client.jobs.interview_details,
                                                    title:'Interview Details',
                                                    step: 3
                                                },
                            'scorecards'      : {
                                                    link: REDIRECT.client.jobs.scorecards,
                                                    title:'Scorecards',
                                                    step: 4
                                                },
                            'job-sharing'     : {
                                                    link: REDIRECT.client.jobs.job_sharing,
                                                    title:'Sharing',
                                                    step: 5
                                                }
                        },
    title:'Jobs',
    allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN,   CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER, SUB_ADMIN]
  },
  candidates: {
    link: '/clients/candidates',
    active: false,
    subsidebar_status: 'close',
    subSidebar_options: null,
    title:'Candidates',
    allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ADMIN, CLIENT_ROLES.CLIENT_USER, SUB_ADMIN]
  },

  reports: {
     link: REDIRECT.client.reports.interview_by_stages,
     active: false,
     subsidebar_status: 'close',
     type: 'menu',
     title:'Reports',
     allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ADMIN, CLIENT_ROLES.CLIENT_USER, SUB_ADMIN],
     subSidebar_options: {
                            'current_pipeline':{
                                                      link:  REDIRECT.client.reports.interview_by_stages,
                                                      title: 'Current Pipeline',
                                                      allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN,  CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER, SUB_ADMIN],
                                                  },
                            'pipeline_speed':{
                                link:  REDIRECT.client.reports.pipeline_speed,
                                title: 'Pipeline Speed',
                                allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN,  CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER, SUB_ADMIN],
                            },
                            'pipeline_conversion':{
                                link:  REDIRECT.client.reports.pipeline_conversion,
                                title: 'Pipeline Conversion',
                                allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN,  CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER, SUB_ADMIN],
                            },
                            'time-to-hire':{
                                                link: REDIRECT.client.reports.time_to_hire,
                                                title: 'Time To Hire',
                                                allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN, CLIENT_ROLES.ACCOUNT_OWNER, ADMIN, CLIENT_ROLES.CLIENT_USER, SUB_ADMIN],
                                           },
                            'source':{
                                              link:  REDIRECT.client.reports.source+'?date_choice=all_time',
                                              title: 'Source of Candidates',
                                              allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN, CLIENT_ROLES.ACCOUNT_OWNER, ADMIN, CLIENT_ROLES.CLIENT_USER, SUB_ADMIN],
                                     },
                            'total-jobs-live-overtime':{
                                                            link:  REDIRECT.client.reports.total_jobs_live_overtime,
                                                            title: 'Jobs over time ',
                                                            allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN,  CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER, SUB_ADMIN],
                                                      },
                            'live-jobs-by-age':{
                                                     link:  REDIRECT.client.reports.live_jobs_by_age,
                                                     title: 'Live Jobs By Age',
                                                     allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN,  CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER, SUB_ADMIN],
                                               },
                            // 'in-process':{
                            //                         link: REDIRECT.client.reports.in_process,
                            //                         title: 'In Process',
                            //                         allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN, CLIENT_ROLES.ACCOUNT_OWNER, ADMIN, CLIENT_ROLES.CLIENT_USER],
                            //               },

                          }
   },
  settings: {
    link: '/settings',
    active: false,
    subsidebar_status: 'close',
    type: 'menu',
    allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN,   CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER, SUB_ADMIN],
    subSidebar_options: {
                            'personal':{
                                          link: '',
                                          title: 'Personal',
                                          allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN,  CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER],
                                          subSidebar_options:{
                                                                'my-account':{
                                                                                  link:  REDIRECT.client.settings.personal.my_account,
                                                                                  title: 'My Account'
                                                                            },
                                                                'notification-setting':{
                                                                                        link: '/clients/notification-setting?type=email',
                                                                                        title: 'My Notifications'
                                                                                      },
                                                                'my-preferences':{
                                                                                    link: REDIRECT.client.my_preferences,
                                                                                    title: 'My Preferences'
                                                                                }

                                                              }
                                       },
                            'company':{
                                          link: '',
                                          title: 'Company',
                                          allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,  CLIENT_ROLES.CLIENT_USER,  ADMIN, SUB_ADMIN],
                                          subSidebar_options:{

                                            'company-profile':{
                                                                link: REDIRECT.client.company.company_profile,
                                                                title:'Profile',
                                                                allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN, SUB_ADMIN]
                                                              },
                                            'add-team':{
                                                        link: REDIRECT.client.company.add_team,
                                                        title:'Team',
                                                        allowed_user_type: [ADMIN, SUB_ADMIN]
                                                      },
                                            'agencies':{
                                              link: REDIRECT.client.company.agencies,
                                              title:'Agencies',
                                              allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ADMIN, CLIENT_ROLES.CLIENT_USER, SUB_ADMIN]
                                            }
                                          }
                                      },
                            'integrations': {
                                              link: '',
                                              title: 'Integrations',
                                              subSidebar_options:{
                                                                      'my-integration':{
                                                                                        link: REDIRECT.client.my_integrations,
                                                                                        title: 'My Integrations',
                                                                                        allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ADMIN, CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER]
                                                                                      },
                                                                      'company-integrations':{
                                                                                                link: REDIRECT.client.company_integrations,
                                                                                                title:'Company Integrations',
                                                                                                allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, SUB_ADMIN]
                                                                                            },
                                                                      'jobs-api':{
                                                                                  link:REDIRECT.client.jobs_api,
                                                                                  title:'Jobs API',
                                                                                  allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER]
                                                                                }
                                                                  },
                                              allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN,  CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER, SUB_ADMIN]
                                            },
                            'career-site':{
                                            link: '',
                                            title: 'Career Site',
                                            subSidebar_options:{
                                                                    'carrer-settings':{
                                                                                  link: REDIRECT.client.career_site.settings,
                                                                                  title:'Settings'
                                                                               },
                                                                    'customize':{
                                                                                   link: REDIRECT.client.career_site.customize,
                                                                                   title:'Customise'
                                                                                }
                                                               },
                                            allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, SUB_ADMIN]
                                          },
                            'recruitment':{
                                            link: '',
                                            title: 'Recruitment',
                                            allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ADMIN, CLIENT_ROLES.CLIENT_USER, SUB_ADMIN],
                                            subSidebar_options:{
                                                                  'scorecard-templates':{
                                                                                link: REDIRECT.client.recruitment.scorecard_templates,
                                                                                title:'Scorecard Templates'
                                                                        },
                                                                  'email-templates':{
                                                                                link: REDIRECT.client.recruitment.email_templates,
                                                                                title:'Email Templates'
                                                                        },
                                                                  'calendar-invites':{
                                                                          link: REDIRECT.client.recruitment.calendar_invites,
                                                                          title:'Calendar Invites',
                                                                          allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER]
                                                                        },
                                                                  'unsuccessful-reasons':{
                                                                                link: REDIRECT.client.recruitment.unsuccessful_reasons,
                                                                                title:'Unsuccessful Reasons'
                                                                              },
                                                                   'manage-assessment':{
                                                                                link: REDIRECT.client.recruitment.manage_assessment,
                                                                                title:'Manage Assessments'
                                                                              },
                                                                    'contract-templates':{
                                                                      link: REDIRECT.client.recruitment.contract_templates,
                                                                      title:'Contract Templates'
                                                                    }
                                                                }
                                          },
                            'data-privacy':{
                                              link: '',
                                              title: 'Data & Privacy',
                                              allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN, CLIENT_ROLES.ACCOUNT_OWNER, SUB_ADMIN],
                                              subSidebar_options:{
                                                'privacy-policy':{
                                                              link: REDIRECT.client.settings.data_privacy.privacy_policy,
                                                              title:'Privacy Policy'
                                                            }
                                                }
                                            }
                        },
    title:'Settings'
  }
}] ;


export const ADMIN_SIDEBAR_OPTIONS = [{
  activities: {
    link: '/admins/activities/activity',
    active: false,
    subsidebar_status: 'close',
    type: 'menu',
    subSidebar_options: null,
    title:'View Activity',
    allowed_user_type: [ADMIN, SUB_ADMIN]
  },
  clients: {
    link: REDIRECT.admins.dashboard.clients.client,
    active: false,
    subsidebar_status: 'close',
    type: 'steps',
    allowed_user_type: [ADMIN, SUB_ADMIN],
    subSidebar_options: {
                            "company":{
                                         link: REDIRECT.admins.dashboard.clients.edit,
                                         title:'Company',
                                         step: 0
                                      },
                            // "add-users" :{
                            //             link: REDIRECT.admins.dashboard.clients.users,
                            //             title:'Users',
                            //             step: 1
                            //         },
                            'integrations':{
                                              link: REDIRECT.admins.dashboard.clients.integration,
                                              title:'Integrations',
                                              step: 2
                                           }
                        },
    title:'Clients'
  },
  users: {
    link: '/admins/users',
    active: false,
    subsidebar_status: 'close',
    type: 'menu',
    subSidebar_options: null,
    title:'Users',
    allowed_user_type: [ADMIN, SUB_ADMIN]
  }

}];


export const AGENCY_SIDEBAR_OPTIONS = [{
  activities: {
    link: REDIRECT.agency.dashboard.activities,
    active: false,
    subsidebar_status: 'close',
    type: 'menu',
    subSidebar_options: null,
    title:'Activity',
    allowed_user_type: [AGENCIES_ROLES.AGENCY_USER, AGENCIES_ROLES.AGENCY_ADMIN ],
  },
  jobs: {
    link: REDIRECT.agency.dashboard.jobs,
    active: false,
    subsidebar_status: 'close',
    type: 'menu',
    subSidebar_options: null,
    title:'Jobs',
    allowed_user_type: [AGENCIES_ROLES.AGENCY_USER, AGENCIES_ROLES.AGENCY_ADMIN ],
  },
  users: {
     link: REDIRECT.agency.dashboard.users,
     active: false,
     subsidebar_status: 'close',
     type: 'menu',
    subSidebar_options: null,
     title:'Users',
     allowed_user_type: [AGENCIES_ROLES.AGENCY_ADMIN]
    },
  settings: {
     link: REDIRECT.agency.dashboard.profile,
     active: false,
     subsidebar_status: 'close',
     type: 'menu',
     subSidebar_options: null,
     title:'Agencies Profiles',
     allowed_user_type: [AGENCIES_ROLES.AGENCY_ADMIN]
   }
}] ;
